import { Link, NavLink } from "react-router";
import { Modal } from "./Modal";
import { IconHelp, IconSettings, IconUser } from "./icons";
import { NewDot } from "../features/helpcenter/NewDot";
import { ORG_PATH, PROFILE_PATH, type NavGroup } from "./navItems";

/** Sheet "Menu" op de telefoon: hetzelfde menu als de rail op desktop, met hulp, organisatie en profiel. */
export function MenuSheet({
  id,
  groups,
  pathname,
  helpTo,
  showOrg,
  onClose,
}: {
  id: string;
  groups: NavGroup[];
  pathname: string;
  helpTo: string;
  showOrg: boolean;
  onClose: () => void;
}) {
  return (
    <Modal id={id} title="Menu" onClose={onClose}>
      <nav className="morelist" aria-label="Menu">
        {groups.map((g, i) => (
          <div key={g.label ?? i} className="navsection" role={g.label ? "group" : undefined} aria-label={g.label}>
            {g.label && <p className="label navgroup">{g.label}</p>}
            {g.items.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className="menuitem"
                title={item.title !== item.label ? item.title : undefined}
                aria-current={item.active(pathname) ? "page" : undefined}
                onClick={onClose}
              >
                <item.Icon size={22} aria-hidden="true" />
                {item.label}
                {item.count ? (
                  <span className="navcount num" aria-hidden="true">
                    {item.count}
                  </span>
                ) : null}
              </Link>
            ))}
          </div>
        ))}
        <div className="pm-sep" />
        <NavLink to={helpTo} className="menuitem" onClick={onClose}>
          <IconHelp size={22} aria-hidden="true" />
          Hulp en support
          <NewDot />
        </NavLink>
        {showOrg && (
          <NavLink to={ORG_PATH} className="menuitem" onClick={onClose}>
            <IconSettings size={22} aria-hidden="true" />
            Organisatie
          </NavLink>
        )}
        <NavLink to={PROFILE_PATH} className="menuitem" onClick={onClose}>
          <IconUser size={22} aria-hidden="true" />
          Profiel en instellingen
        </NavLink>
      </nav>
    </Modal>
  );
}
